export interface IsValidRegexOptions {
  required?: boolean;
}

export function isValidRegex(value?: string, _propertyName?: string, _entity?: unknown, params?: IsValidRegexOptions) {
  if (!value) {
    return !params?.required;
  }

  try {
    new RegExp(value);
    return true;
  } catch {
    return false;
  }
}
